import { createSlice } from "@reduxjs/toolkit";
import {
  CreateSimpleQuestionThunk,
  downloadPDFThunk,
  GetBoardsThunk,
  GetClasesThunk,
  GetClasssesNewThunk,
  GetClassSubjectChaptersThunk,
  GetCreatedPapersThunk,
  GetMediumThunk,
  GetPaperMetaDataThunk,
  GetQuestionCategoriesThunk,
  GetQuestionsThunk,
  GetSubjectChaptersThunk,
  GetSubjectsNewThunk,
  GetSubjectsThunk,
  SaveQuestionPaperThunk,
  FetchExamsBySchoolThunk,
  PublishQuestionPaperThunk,
  UnpublishQuestionPaperThunk,
} from "./thunk";
import toast from "react-hot-toast";

const initialState = {
  stage: 1,
  loader: false,
  error: null,
  classes: [],
  subjects: [],
  categories: [],
  chapters: [],
  questions: [],
  questionsCopy: [],
  categoryName: "",
  headerPanel: false,
  questionsPanel: false,
  categoryPanel: false,
  createdpapers: [],
  selectedTab: 1,
  isSubmitted: false,
  formData: {
    type: "Question paper",
    maxMarks: "",
    duration: "",
    class: "",
    subject: "",
    category: "",
    chapter: "",
    schoolName: "",
    examName: "",
    termsText: "",
    displayTerms: "true",
    displayHeader: "true",
    // headerType: "1",
    headerTypes: ["1"],
    headerImageUrl: "",
    headerImgHeight: 20,
    headerImgWidth: 100,
    schoolLogoUrl: "",
    logoWidth: 15,
    logoHeight: 15,
    logoPosition: "left",
    board_id: "",
    medium_id: "",
  },
  isOpen: false,
  selectedQnCategory: [],
  selectedChapter: null,
  isJoyRideRunning: true,
  boardsList: [],
  mediumList: [],
  classesNew: [],
  subjectsNew: [],
  hours: "",
  minutes: "",
  // Publish Question Paper Modal
  publishModalOpen: false,
  selectedPaper: null,
  examsList: [],
  selectedExamId: "",
  loadingExams: false,
  publishing: false,
};

const CreateQstnPaperSlice = createSlice({
  name: "CreateQstnPaperSlice",
  initialState,
  reducers: {
    handleStage(state, action) {
      state.stage = action.payload;
    },
    handlePopup(state, action) {
      state.isOpen = action.payload;
    },
    handleCategory(state, action) {
      state.selectedQnCategory = action.payload;
    },
    setSelectedChapter: (state, action) => {
      state.selectedChapter = action.payload;
    },
    setFormData(state, action) {
      const { name, value } = action.payload;
      state.formData = { ...state.formData, [name]: value };

      if (name === "category" && value) {
        state.questions = state.questionsCopy.filter(
          (e) => Number(e.question_typeid) === Number(value),
        );
        state.categoryName =
          state.categories?.find((c) => c.value === value)?.label ||
          "Category Name";

        if (state.chapters.length > 0 && state.formData.chapter) {
          state.questionsPanel = true;
        }
      }
    },

    setDemoUserFormData(state, action) {
      state.formData = { ...state.formData, ...action.payload };
    },

    handleHeader(state, action) {
      state.headerPanel = action.payload;
    },

    handleQstnPanel(state, action) {
      state.questionsPanel = action.payload;
    },

    handleCategoryPanel(state, action) {
      state.categoryPanel = action.payload;
    },

    handleError(state) {
      state.error = null;
    },

    resetFormData(state, action) {
      state.formData = { ...initialState.formData };
      state.isSubmitted = false;
      state.selectedTab = 1;
    },

    handleSelectedTab(state, action) {
      state.selectedTab = action.payload;
    },

    handleSubmit(state, action) {
      state.isSubmitted = action.payload;
    },
    handleJoyRideRunning(state, action) {
      state.isJoyRideRunning = action.payload;
      action.payload === false &&
        localStorage.setItem("questionPaperTourCompleted", "true");
    },
    setField(state, action) {
      const { key, value } = action.payload;
      state[key] = value;
    },
    openPublishModal(state, action) {
      state.publishModalOpen = true;
      state.selectedPaper = action.payload;
      state.selectedExamId = "";
      state.examsList = [];
    },
    closePublishModal(state) {
      state.publishModalOpen = false;
      state.selectedPaper = null;
      state.selectedExamId = "";
      state.examsList = [];
      state.publishing = false;
    },
    setSelectedExamId(state, action) {
      state.selectedExamId = action.payload;
    },
  },
  extraReducers(builder) {
    // GetClasesThunk
    createThunkCases(
      builder,
      GetClasesThunk,
      null,
      "Error Getting Classes",
      (state, action) => {
        state.classes = action.payload.map((e) => ({
          value: e.class_id,
          label: e.class_name,
        }));
      },
    );

    // GetSubjectsThunk
    createThunkCases(
      builder,
      GetSubjectsThunk,
      null,
      "Error Getting Subjects",
      (state, action) => {
        state.subjects = action.payload.map((e) => ({
          value: e.subject_id,
          label: e.subject_name,
        }));
      },
    );

    // GetQuestionCategoriesThunk
    createThunkCases(
      builder,
      GetQuestionCategoriesThunk,
      null,
      "Error Getting Question Categories",
      (state, action) => {
        state.categories = action.payload.map((item) => ({
          value: item.type_id,
          label: item.type_name,
          title: item.type_title,
        }));
      },
    );

    // GetSubjectChapters
    createThunkCases(
      builder,
      GetSubjectChaptersThunk,
      null,
      "Error Getting Subject Chapters",
      (state, action) => {
        state.chapters = action.payload;
      },
    );

    // GetClassSubjectChaptersThunk
    createThunkCases(
      builder,
      GetClassSubjectChaptersThunk,
      null,
      "Error Getting Class Subject Chapters",
      (state, action) => {
        state.chapters = action.payload.map((e) => ({
          value: e.chapter_id,
          label: e.chapter_name,
        }));
      },
    );

    // GetQuestionsThunk
    createThunkCases(
      builder,
      GetQuestionsThunk,
      "questionsCopy",
      "Error Getting Questions",
      (state, action) => {
        state.stage = 2;
        state.questionsPanel = true;
        state.questions = action.payload.filter(
          (e) => Number(e.question_typeid) === Number(state.formData.category),
        );
      },
    );

    // SaveQuestionPaperThunk
    createThunkCases(
      builder,
      SaveQuestionPaperThunk,
      null,
      "Error Saving Question Paper",
      (state, action) => {
        state.formData = { ...initialState.formData };
        // state.stage = 1; // no need here
      },
    );

    // GetCreatedPapers
    createThunkCases(
      builder,
      GetCreatedPapersThunk,
      "createdpapers",
      "Error Getting Question Papers",
      null,
      (state, action) => {
        state.createdpapers = [];
      },
    );

    // GetPaperMetaDataThunk
    createThunkCases(
      builder,
      GetPaperMetaDataThunk,
      null,
      "Error getting Paper Meta Data",
      (state, action) => {
        state.formData = JSON.parse(action.payload.form_data);
      },
    );
    // CreateSimpleQuestionThunk
    createThunkCases(
      builder,
      CreateSimpleQuestionThunk,
      null,
      "Error Creating Question",
      (state, action) => {},
    );
    // generate pdf
    createThunkCases(
      builder,
      downloadPDFThunk,
      null,
      "Error Generating PDF",
      (state, action) => {},
    );

    //get boards
    createThunkCases(
      builder,
      GetBoardsThunk,
      null,
      "Error Getting boards",
      (state, action) => {
        state.boardsList = action.payload;
      },
    );
    builder
      .addCase(GetClasssesNewThunk.pending, (state) => {
        state.loader = true;
      })
      .addCase(GetClasssesNewThunk.fulfilled, (state, action) => {
        state.loader = false;
        state.classesNew = action.payload?.data || [];
      })
      .addCase(GetClasssesNewThunk.rejected, (state, action) => {
        state.loader = false;
        state.error = action.payload;
      });
    builder
      .addCase(GetSubjectsNewThunk.pending, (state) => {
        state.loader = true;
      })
      .addCase(GetSubjectsNewThunk.fulfilled, (state, action) => {
        state.loader = false;
        state.subjectsNew = action.payload?.data || [];
      })
      .addCase(GetSubjectsNewThunk.rejected, (state, action) => {
        state.loader = false;
        state.error = action.payload;
      });
    builder
      .addCase(GetMediumThunk.pending, (state) => {
        state.loader = true;
      })
      .addCase(GetMediumThunk.fulfilled, (state, action) => {
        state.loader = false;
        state.mediumList = action.payload?.data || [];
      })
      .addCase(GetMediumThunk.rejected, (state, action) => {
        state.loader = false;
        state.error = action.payload;
      });

    // FetchExamsBySchoolThunk
    builder
      .addCase(FetchExamsBySchoolThunk.pending, (state) => {
        state.loadingExams = true;
      })
      .addCase(FetchExamsBySchoolThunk.fulfilled, (state, action) => {
        state.loadingExams = false;
        state.examsList = action.payload;
      })
      .addCase(FetchExamsBySchoolThunk.rejected, (state, action) => {
        state.loadingExams = false;
        state.examsList = [];
      });

    // PublishQuestionPaperThunk
    builder
      .addCase(PublishQuestionPaperThunk.pending, (state) => {
        state.publishing = true;
      })
      .addCase(PublishQuestionPaperThunk.fulfilled, (state) => {
        state.publishing = false;
        state.publishModalOpen = false;
        state.selectedPaper = null;
        state.selectedExamId = "";
        state.examsList = [];
      })
      .addCase(PublishQuestionPaperThunk.rejected, (state) => {
        state.publishing = false;
      });
  },
});

export const createThunkCases = (
  builder,
  thunk,
  targetKey = null,
  customErrorMsg,
  extraChanges = null,
  errorChanges = null,
) => {
  builder
    .addCase(thunk.pending, (state, action) => {
      state.loader = true;
      state.error = null;

      if (typeof errorChanges === "function") {
        errorChanges(state, action);
      }
    })
    .addCase(thunk.fulfilled, (state, action) => {
      state.loader = false;
      state.error = null;
      if (targetKey) {
        state[targetKey] = action.payload;
      }

      if (typeof extraChanges === "function") {
        extraChanges(state, action);
      }
    })
    .addCase(thunk.rejected, (state, action) => {
      state.loader = false;
      state.error = action?.payload || action?.error?.message || customErrorMsg;

      if (typeof errorChanges === "function") {
        errorChanges(state, action);
      }
    });
};

export const {
  setFormData,
  handleStage,
  handleHeader,
  handleQstnPanel,
  handleCategoryPanel,
  handleError,
  resetFormData,
  handleSelectedTab,
  handleSubmit,
  setDemoUserFormData,
  handlePopup,
  handleCategory,
  setSelectedChapter,
  handleJoyRideRunning,
  setField,
  openPublishModal,
  closePublishModal,
  setSelectedExamId,
} = CreateQstnPaperSlice.actions;
export default CreateQstnPaperSlice.reducer;
